import { FluentBundle } from 'fluent';
import React, { Children, cloneElement } from 'react';

const parseMarkup = (input: string) => {
  const template = document.createElement('template');
  template.innerHTML = input;
  return Array.from(template.content.childNodes);
};

const convertObjectKeysToLowerCase = (obj: Record<string, any>) => {
  const result: Record<string, any> = {};
  for (const [key, value] of Object.entries(obj)) {
    result[key.toLowerCase()] = value;
  }
  return result;
};

interface Props {
  bundle: FluentBundle;
  messageId: string;
  messageArgs: object;
  children: React.ReactElement<any>;
}

const Localized = (props: Props) => {
  const {bundle, messageId, messageArgs, children} = props;
  try {
    const onlyChild = Children.only(children);
    if (React.isValidElement(onlyChild) === true) {
      const message = bundle.getMessage(messageId);
      const formattedMessage = bundle.format(message, messageArgs);
      const parsedNodes = parseMarkup(formattedMessage);
      const argsWithLowerCaseKeys = convertObjectKeysToLowerCase(messageArgs);
      const parsedChildren = parsedNodes.map((node, i) => {
        if (node.nodeType === node.TEXT_NODE) {
          return node.textContent;
        } else {
          // Need to add `key` to avoid "key errors" in dev mode:
          const reactElem = cloneElement(
            argsWithLowerCaseKeys[(node as Element).localName],
            {key: `item-${i}`},
          );
          return reactElem;
        }
      });

      const elem = cloneElement(onlyChild, {children: parsedChildren});
      return elem;
    } else {
      throw new Error('Child of Localized must be a true React element, not string or number');
    }

  } catch (e) {
    throw new Error(e);
  }
};

export default Localized;
